import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import {USER_URL, REFERENCES_URL, AUTH_URL} from '../../../vars'

/**
 * @namespace PersonalData
 * @description Личный кабинет (Page: /personak-data)
 */
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    /**
     *
     * @param {Object} ctx
     * @param {Object} data Данные для обновления личной информации
     * @returns {object} Резуьтат обновления данных
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async UPDATE_INDIVIDUAL(ctx, data) {
      try {
        const res = await axios.patch(`${USER_URL}individual/detail/`, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`
          }
        })
        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },

    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_DEGREE(ctx) {

      const headers = {
        headers: {
          Authorization: `Token ${localStorage.token}`,
        }
      };

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-degree/list/`, headers)
        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },
    /**
     * Возвращает резуьтат запроса
     * @param {Object} ctx
     * @param {String} data Язык данных
     * @returns {object} Данные на другом языке
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_ACADEMIC_DEGREE_REG(ctx) {

      try {
        const res = await axios.get(`${REFERENCES_URL}academic-degree/list/`)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },

    async GET_ORG_POSITION_LIST(ctx) {

      try {
        const res = await axios.get(`${REFERENCES_URL}org-position/list/`)

        return res
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    },


    /**
     *
     * @param {Object} ctx
     * @returns {Object} Данные профиль пользователя
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof PersonalData
     */
    async GET_PERSONAL_DATA(ctx) {
      try {
        const {data} = await axios.get(`${AUTH_URL}profile/`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          }
        })

        return data
      } catch (e) {
        errorHelper(e)
        messageHelper('', 'error', 6000, e)
        throw e
      }
    }
  },
  getters: {
  }
}
